import { Controller } from "@hotwired/stimulus"

// Generic submit spinner and validation for all login/register forms.
export default class extends Controller {
  static targets = ["submit", "label", "spinner"]

  connect() {
    this.form = this.element.tagName === "FORM"
      ? this.element
      : this.element.querySelector("form")

    if (this.form && this.hasSubmitTarget) {
      this.requiredInputs = Array.from(this.form.querySelectorAll("input[required]"))
      if (this.requiredInputs.length > 0) {
        this.validate = this.validate.bind(this)
        this.requiredInputs.forEach(input => {
          input.addEventListener("input", this.validate)
        })
        // Initial validation
        this.validate()
      }
    }
  }

  disconnect() {
    if (this.requiredInputs && this.requiredInputs.length > 0) {
      this.requiredInputs.forEach(input => {
        input.removeEventListener("input", this.validate)
      })
    }
  }

  validate() {
    const allFilled = this.requiredInputs.every(input => input.value.trim() !== "")
    this.submitTarget.disabled = !allFilled
  }

  submit(event) {
    if (this.form && !this.form.checkValidity()) return

    // If we disable the button, native form submission might not fire,
    // so we disable it after a tiny timeout to allow the event to bubble.
    setTimeout(() => {
      this.submitTarget.disabled = true
      this.labelTarget.textContent = this.labelTarget.textContent.includes("Signing")
        ? this.labelTarget.textContent
        : "Signing in..."
      this.spinnerTarget.classList.remove("hidden")
    }, 10)
  }
}
